import Vue from "vue"

export default {
  mounted: function () {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) {
        f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = "2.0"
      }
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    )
    this.fbq_init()
  },
  methods: {
    fbq_init: function () {
      const lgin = this.$store.getters["user/IS_LOGGED_IN"]
      const id = Vue.config.devtools ? "1804035823056692" : "2198726890193216"
      var config = lgin ? { uid: this.$store.state.user.id } : undefined

      fbq("init", id, config)
      if (lgin) {
        fbq("setUserProperties", id, {
          $user_type: this.$store.getters["user/KIND"],
          $language: this.displayLang,
          is_visible: this.$store.state.user.is_visible,
          is_authorized: this.$store.state.user.is_authorized,
          email: this.$store.state.user.email,
          first_name: this.$store.state.user.first_name,
          influencer: this.$store.state.user.influencer,
          bands: this.$store.state.user.band_set,
          submissions: this.$store.state.user.submissions,
        })
      }
    },
  },
}
